import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface InteractiveGenerationState {
  isInteractiveGeneration: boolean;
  setIsInteractiveGeneration: (isInteractive: boolean) => void;
}

export const useInteractiveGenerationStore = create(
  persist<InteractiveGenerationState>(
    (set) => ({
      isInteractiveGeneration: false,
      setIsInteractiveGeneration: (interactive) => set({ isInteractiveGeneration: interactive }),
    }),
    {
      name: 'interactive-generation-storage', 
    }
  )
);